/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
// import M_logo from '../../assets/logo M.png';
// import
import { PiPlusThin } from "react-icons/pi";
import { MdEdit } from "react-icons/md";
import { IoSearch } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { MdDelete } from "react-icons/md";
import axios from "axios";

import DocumentTitle from "../../utils/DocumentTitle";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import socket from "../../services/socket";

const Series = () => {
  DocumentTitle("Mangas.IO translator");
  const navigate = useNavigate();
  const [isLogedin, setIsLogedIn] = useState();
  // create a serie
  let serie = { idx: 0, titre: "", fk_utilisateur: "2" };
  let [listOfSeries, setListOfSeries] = useState([]);
  //update status
  const [updateStatus, setUpdateStatus] = useState("Update");
  const [isUpdated, setIsUpdated] = useState(null);
  const [isCreated, setIsCreated] = useState(false);
  const [Searching, setSearching] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersUp, setUsersUp] = useState([]);
  const [usersAlreadyAffected, setUsersAlreadyAffected] = useState([]);
  const [loggedUser, setLoggedUser] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [allUsersUp, setAllUsersUp] = useState([]);
  const [selectedSerie, setSelectedSerie] = useState();
  const [usersFromDB, setUsersFromDB] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  // get all notifications
  useEffect(() => {
    // const socket = io.connect('http://127.0.0.1:4000', { forceNew: true });
    // socket.on('connect', () => {
    //     console.log('Connected to the server with ID:', socket.id);
    // });
    try {
      const token = localStorage.getItem("login_token");
      const user = JSON.parse(localStorage.getItem("login_user"));
      if (token && user) {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/notification/get/${user.id}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            let newOnes = res.data.filter((n) => n.statut === "sent");
            setNewNotifications([...newOnes]);
            setNotifications([...res.data]);
          });
      }
    } catch (error) {
      toast.error("Can't get notifications");
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("login_token");
    const user = JSON.parse(localStorage.getItem("login_user"));
    setLoggedUser(user);
    if (!token) {
      navigate("/login");
      setIsLogedIn(false);
    } else {
      setIsLogedIn(true);
      axios
        .get(`${process.env.REACT_APP_HOST_API}/api/serie/getAll`, {
          headers: { Authorization: token },
        })
        .then((res) => {
          if (res.status === 200) {
            console.log("series res : ", res.data);
            setListOfSeries([...res.data]);
            axios
              .get(`${process.env.REACT_APP_HOST_API}/api/user`, {
                headers: { Authorization: token },
              })
              .then((resp) => {
                if (resp.status === 200) {
                  console.log("all users : ", resp.data);
                  let users = [];
                  resp.data.forEach((u) => {
                    if (u._id !== loggedUser.id) {
                      users.push({
                        nom_utilisateur: u.nom_utilisateur,
                        _id: u._id,
                      });
                    }
                  });
                  console.log("new all users : ", users);
                  setAllUsers([...users]);
                  setUsersFromDB([...users]);
                } else if (
                  resp.response.status === 400 ||
                  resp.response.status === 500 ||
                  resp.response.status === 401
                ) {
                  toast.error("Something wrong");
                }
              });
          }
        });
    }
  }, [isUpdated, isCreated, Searching]);

  // show hide sub list
  const [toggleSubList, setToggleSubList] = useState(false);
  const showHideSubList = () => {
    setToggleSubList(!toggleSubList);
  };

  document.addEventListener("click", (e) => {
    if (toggleSubList && e.target.id !== "avatar") {
      setToggleSubList(false);
    }
  });

  // to open the modale add serie
  let [isOpened, setIsOpened] = useState(false);

  const openAddSerieModale = () => {
    setIsOpened(true);
    if (!isOpened) {
      setUsers([]);
      setAllUsers([...usersFromDB]);
    }
  };

  const closeAddSerieModale = (e) => {
    let id = e.target.id;
    if (id === "add_serie_modale" || id === "back") {
      setIsOpened(false);
    }
  };

  // end

  // search for serie
  const [filteredList, setFilteredList] = useState([]);
  const searchSerie = (e) => {
    let se = e.target.value;

    if (se[0] === " ") {
      e.target.value = "";
    } else {
      se = se.trim();
      if (se.length !== 0) {
        setSearching(true);
        let newListOfSeries = listOfSeries.filter((el) =>
          el.titre.toLowerCase().includes(se)
        );
        setFilteredList([...newListOfSeries]);
      } else {
        setListOfSeries([]);
        setSearching(false);
      }
    }
  };

  // push user to the list on creation
  const addUserToList = (e) => {
    e.preventDefault();
    let user = document.getElementById("user");
    setUsers([
      ...users,
      {
        nom_utilisateur: user.value,
        _id: user.options[user.selectedIndex].id,
        new: true,
      },
    ]);
    setAllUsers(allUsers.filter((ele) => ele.nom_utilisateur !== user.value));
    console.log(
      "user : ",
      user.value,
      "id : ",
      user.options[user.selectedIndex].id
    );
  };

  // push user to the list on update
  const addUserToListOnUpdate = (e) => {
    e.preventDefault();
    let user = document.getElementById("user-up");
    console.log("user up ", user);
    setUsersUp([
      ...usersUp,
      {
        nom_utilisateur: user.value,
        _id: user.options[user.selectedIndex].id,
        new: true,
      },
    ]);
    setAllUsersUp(
      allUsersUp.filter((ele) => ele.nom_utilisateur !== user.value)
    );
    console.log(
      "user-up : ",
      user.value,
      "id : ",
      user.options[user.selectedIndex].id
    );
  };

  const removeUserOnCreation = (e) => {
    let data = e.target.id;
    let removedUserId = data.split("-")[0];
    let removedUserName = data.split("-")[1];

    setUsers(users.filter((ele) => ele._id !== removedUserId));
    setAllUsers([
      ...allUsers,
      { nom_utilisateur: removedUserName, _id: removedUserId },
    ]);
  };

  // remove user from list
  const removeUser = (e) => {
    let data = e.target.id;
    let removedUserId = data.split("-")[0];
    let removedUserName = data.split("-")[1];
    const token = localStorage.getItem("login_token");
    console.log("logged user : ", loggedUser, " serie : ", selectedSerie);
    if (token && selectedSerie.fk_utilisateur === loggedUser.id) {
      let body = {
        fk_serie: selectedSerie._id,
        fk_utilisateur: removedUserId,
      };
      console.log("body ", body);
      console.log("token ", token);
      try {
        axios
          .delete(`${process.env.REACT_APP_HOST_API}/api/serie/equipe`, {
            headers: { Authorization: token },
            data: body,
          })
          .then((resp) => {
            if (resp.status === 200) {
              console.log("remove user resp : ", resp);
              console.log("id : ", removedUserId, "name : ", removedUserName);
              // document.getElementById(`${data}-parent`).style.display = 'none';
              let newUsers = usersUp.filter((ele) => ele._id !== removedUserId);
              setUsersUp([...newUsers]);
              setAllUsersUp([
                ...allUsersUp,
                { nom_utilisateur: removedUserName, _id: removedUserId },
              ]);
              toast.success("User has been removed successfully");
            }
          });
      } catch (error) {
        toast.error("You cannot remove users");
      }
    } else {
      toast.error("You are not authorized to remove users");
    }
  };

  // to push the obj in the list of series
  const createSerie = async () => {
    // console.log(serie)
    setLoading(true);
    const token = localStorage.getItem("login_token");
    // setListOfSeries([...listOfSeries, serie]);
    console.log("s : ", serie.titre);
    let serie_title = document.getElementById("titre").value;
    const title = serie_title.trim();
    const organisation = loggedUser?.organisation;
    console.log("organisation : ", organisation);
    if (title === "") {
      toast.error("Please provide a title for the new serie.");
    }
    if (token && title !== "") {
      // console.log(token)
      try {
        // send serie with axios
        await axios
          .post(
            `${process.env.REACT_APP_HOST_API}/api/serie/create`,
            { titre: title, organisation: organisation },
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              let affectedUsers = [];
              users.map((u) => affectedUsers.push(u._id));
              // affectedUsers.push(res.data.fk_utilisateur)
              let body = {
                fk_utilisateur: affectedUsers,
                fk_serie: res.data._id,
              };
              console.log("body : ", body);
              try {
                axios
                  .post(
                    `${process.env.REACT_APP_HOST_API}/api/serie/equipe`,
                    body,
                    {
                      headers: { Authorization: token },
                    }
                  )
                  .then((resp) => {
                    console.log("affected resp : ", resp);
                    setIsCreated(true);
                    setIsOpened(false);
                    setLoading(false);
                  });
              } catch (error) {
                toast.error("Something wrong while assigning users");
                setLoading(false);
                console.log("users affected : ", error);
              }
              console.log("serie created : ", res.data);
            }
          });
      } catch (error) {
        if (
          error.response.status === 400 ||
          error.response.status === 500 ||
          error.response.status === 401
        ) {
          toast.error("Something wrong while creating serie");
        }
        console.log(error);
      }
    }
  };
  console.log("loggedUser : ", loggedUser);

  // edit serie
  let [edit, setEdit] = useState(false);
  let [updatedSerie, setUpdatedSerie] = useState({});
  // let [newSerieUpdated, setNewSerieUpdated] = useState({});

  // to get data from the form
  // const onChangeHandler = (e) => {
  //     let idx = listOfSeries.length;
  //     serie = { ...serie, [e.target.name]: e.target.value, idx };
  // }
  // end

  // filter two arrays
  const symmetricDifferenceById = (arr1, arr2) => {
    // Create sets of ids from both arrays
    const set1 = new Set(arr1.map((item) => item._id));
    const set2 = new Set(arr2.map((item) => item._id));
    console.log("arr 1 : ", arr1, " and arr 2 ", arr2);
    console.log("set 1 : ", set1, " and set2 ", set2);

    // Filter objects that are in arr1 but not in arr2
    const uniqueToArr1 = arr1.filter((item) => !set2.has(item._id));
    // Filter objects that are in arr2 but not in arr1
    const uniqueToArr2 = arr2.filter((item) => !set1.has(item._id));

    // Combine the results
    return [...uniqueToArr1, ...uniqueToArr2];
  };

  const editSerie = (s, idx) => {
    setSelectedSerie(s);
    console.log("s ", s);
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        axios
          .get(`${process.env.REACT_APP_HOST_API}/api/serie/${s._id}/users`, {
            headers: { Authorization: token },
          })
          .then((res) => {
            let result = symmetricDifferenceById(allUsers, res.data);
            setAllUsersUp([...result]);
            console.log("result ", result);
            setUsersUp([...res.data]);
            setUsersAlreadyAffected([...res.data]);
            setUpdatedSerie({ ...s, idx });
            setEdit(!edit);
            console.log("get all affected res : ", res.data);
          });
      } catch (error) {
        toast.error("Something wrong while getting assigned users");
        console.log("get all affected users err : ", error);
      }
    }
    // setUpdatedSerie({ ...s, idx });
    // setEdit(!edit);
    console.log("allUsersUp : ", allUsersUp);
  };
  // update : on change
  const onUpdateHandler = (e) => {
    let newSerie = { ...updatedSerie, [e.target.name]: e.target.value };
    setUpdatedSerie(newSerie);
  };
  // update a serie
  const updateSerie = async () => {
    const token = localStorage.getItem("login_token");
    console.log("updated serie : ", updatedSerie);
    console.log("token : ", token);
    if (token) {
      setUpdateStatus("Updating...");
      setLoading(true);
      try {
        await axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/serie/modify/${updatedSerie._id}`,
            updatedSerie,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log("put res : ", res.status);
            if (res.status === 200) {
              let affectedUsers = [];
              console.log("users : ", users);
              console.log("usersAlreadyAffected : ", usersAlreadyAffected);
              usersUp.map((u) => affectedUsers.push(u._id));
              let body = {
                fk_utilisateur: affectedUsers,
                fk_serie: res.data._id,
              };
              console.log("body : ", body);
              if (usersUp.length > usersAlreadyAffected.length) {
                try {
                  axios
                    .post(
                      `${process.env.REACT_APP_HOST_API}/api/serie/equipe`,
                      body,
                      {
                        headers: { Authorization: token },
                      }
                    )
                    .then((resp) => {
                      console.log("affected resp : ", resp);
                      if (resp.status === 200) {
                        setUpdateStatus("Update");
                        setIsUpdated(resp.data);
                        setEdit(false);
                        if (affectedUsers.length !== 0) {
                          let names = usersUp
                            .filter((el) => el.new === true)
                            .map((p) => p.nom_utilisateur);
                          console.log("names : ", names);

                          let date = new Date();
                          let action = {
                            fk_utilisateur: loggedUser.id,
                            fk_serie: updatedSerie._id,
                            fk_tome: "null",
                            contenu: `${
                              loggedUser.username
                            } has added new user(s) "${names.join(
                              " and "
                            )}" to the serie "${updatedSerie.titre}"`,
                            target_user: "",
                            date: date.toISOString(),
                            statut: "sent",
                          };
                          console.log("comment action : ", action);
                          let sendTo = usersUp.filter(
                            (el) => el._id !== loggedUser.id
                          );
                          console.log("comment sendTo : ", sendTo);
                          socket.emit("validate", action, sendTo);
                        }
                      }
                    });
                } catch (error) {
                  toast.error("Something wrong while updating assigned users");
                  console.log("users affected : ", error);
                }
              } else {
                setUpdateStatus("Update");
                setIsUpdated(res.data);
                setEdit(false);
              }
            }
          });
      } catch (error) {
        if (
          error.response.status === 400 ||
          error.response.status === 500 ||
          error.response.status === 401
        ) {
          toast.error("You are not authorized to update this serie");
        }
        console.log("update title : ", error);
      } finally {
        setLoading(false);
      }
    } else {
      navigate("/login");
    }
  };
  console.log("users to assign : ", users);

  // back from update form
  const closeUpdateSerieModale = (e) => {
    let id = e.target.id;
    if (id === "add_serie_modale_update" || id === "back_update") {
      setEdit(false);
    }
  };

  // auto read notifs
  const updateNotifsWhenOpen = async (notifications) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      for (let i = 0; i < notifications.length; i++) {
        if (notifications[i].statut === "sent") {
          try {
            await axios
              .put(
                `${process.env.REACT_APP_HOST_API}/api/notification/update_statut/${notifications[i]._id}`,
                {},
                {
                  headers: { Authorization: token },
                }
              )
              .then((res) => {
                console.log("res update notifs to seen : ", res);
                if (res.status === 200) {
                  setNewNotifications([]);
                }
              });
          } catch (error) {
            console.log("update notif to seen err : ", error);
          }
        }
      }
    }
  };

  const [toggleNotif, setToggleNotif] = useState(false);
  useEffect(() => {
    console.log("toggleNotif : ", toggleNotif);
    console.log("notifications : ", notifications);
    if (toggleNotif && notifications.length !== 0) {
      updateNotifsWhenOpen(notifications);
      setNewNotifications([]);
    }
  }, [toggleNotif]);

  // show notifications start
  const showHideNotif = () => {
    setToggleNotif(!toggleNotif);
  };

  document.addEventListener("click", (e) => {
    let el = e.target.id || e.target.parentElement?.id;
    if (el !== "notif") {
      setToggleNotif(false);
    }
  });
  // show notifications end

  // socket get notifs
  useEffect(() => {
    if (selectedSerie?._id) {
      socket.on("notification", (list) => {
        let newList = list.filter((el) => el.target_user === loggedUser.id);
        setNewNotifications([...newList]);
        setNotifications([...notifications, ...newList]);
      });
    }

    return () => {
      socket.off("notification");
    };
  }, [loggedUser?.id, selectedSerie]);

  console.log("notifications : ", notifications);
  console.log("newNotifications : ", newNotifications);
  console.log("updatedSerie : ", updatedSerie);

  if (isLogedin) {
    return (
      <div className="series_container">
        <div className="series_header">
          <div className="series_logo">
            {/* <img src={M_logo} alt="MangasIO_Logo" /> */}
            <img
              src={require("../../assets/logo mangasio.svg").default}
              alt="mySvgImage"
            />
          </div>
          <div className="series_search">
            <input
              type="search"
              name="search_serie"
              id="search_serie"
              placeholder="Search series"
              onChange={searchSerie}
            />
            <span>
              <IoSearch />
            </span>
          </div>
          <div className="series_avatar">
            <div
              id="notif"
              className="notif"
              title="Notifications"
              onClick={showHideNotif}
              style={newNotifications.length !== 0 ? { color: "#bd2969" } : {}}
            >
              <FaBell id="notif" />
              <span className="num_of_notifs">
                {newNotifications?.length < 10
                  ? newNotifications?.length
                  : "+9"}
              </span>
            </div>
            <div
              id="avatar"
              className="avatar"
              onClick={showHideSubList}
              style={
                toggleSubList
                  ? {
                      border: "1px solid rgb(214, 65, 10)",
                      color: "rgb(214, 65, 10)",
                    }
                  : { border: "none", color: "black" }
              }
            >
              {loggedUser?.username[0].toUpperCase()}
              {loggedUser?.organisation !== "mangasIO" && (
                <span className="org">{loggedUser?.organisation}</span>
              )}
            </div>
            {toggleSubList && (
              <div className="sub_list">
                <Link className="item" to="/profile">
                  Settings
                </Link>
                <Link className="item" to="/logout">
                  Sign out
                </Link>
              </div>
            )}
            {toggleNotif && (
              <div className="notif_list">
                {notifications?.length !== 0 ? (
                  [...notifications].reverse()?.map((n, i) => {
                    return (
                      <span
                        key={i}
                        className="nofit_item"
                        style={
                          n.statut === "seen"
                            ? { backgroundColor: "#1510188f" }
                            : { backgroundColor: "#bd2969" }
                        }
                      >
                        {n.contenu}
                      </span>
                    );
                  })
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: ".8rem",
                      color: "#e8e5e5",
                    }}
                  >
                    No notifications yet !!
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="series_content">
          <h2>Series</h2>
          <div className="series_cards">
            <div
              className="add_serie_card"
              title="Add new serie"
              onClick={openAddSerieModale}
            >
              <div className="add_serie_icon">
                <PiPlusThin />
              </div>
              <div className="add_serie_text">Create a new serie</div>
            </div>
            {(!Searching ? listOfSeries : filteredList)?.map((s, idx) => {
              return (
                <div className="serie_card" key={idx}>
                  <Link to={"/tome/" + s?._id}>{s?.titre}</Link>
                  <span className="serie_card_details">
                    <div className="row">
                      <span>
                        Serie {idx + 1} : {s?.titre}
                      </span>
                      <span
                        className="edit"
                        title="Edit"
                        onClick={() => editSerie(s, idx)}
                      >
                        <MdEdit />
                      </span>
                    </div>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        {/* add serie modale */}
        {isOpened && (
          <div
            id="add_serie_modale"
            className="add_serie_modale"
            onClick={closeAddSerieModale}
          >
            <div className="add_serie_modale_content">
              <h2>New serie</h2>
              <form action="">
                <div className="add_serie_form">
                  <div className="add_serie_form_left">
                    <div className="input_block">
                      <label htmlFor="titre">Title</label>
                      <input
                        type="text"
                        name="titre"
                        id="titre"
                        placeholder="Title"
                        required
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="user">Authorized users</label>
                      <select name="fk_utilisateur" id="user">
                        {allUsers?.map((u, i) => {
                          if (u._id !== loggedUser.id) {
                            return (
                              <option
                                id={u._id}
                                key={i}
                                value={u.nom_utilisateur}
                              >
                                {u?.nom_utilisateur}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </select>
                      <button className="add_user" onClick={addUserToList}>
                        Add Selected User
                      </button>
                    </div>
                  </div>
                  <div className="add_serie_form_right">
                    <div className="users_block">
                      {users?.map((u, i) => {
                        return (
                          <div key={i} className="user_added">
                            {u.nom_utilisateur[0]}
                            <span
                              id={`${u._id}-${u.nom_utilisateur}`}
                              className="delete_user"
                              onClick={removeUserOnCreation}
                            >
                              x
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="add_serie_form_btns">
                  <button type="button" id="back" onClick={closeAddSerieModale}>
                    Back
                  </button>
                  <button type="button" id="cree" onClick={createSerie}>
                    {loading && (
                      <span className="create_spin">
                        <AiOutlineLoading3Quarters />
                      </span>
                    )}{" "}
                    Create
                  </button>
                </div>
              </form>
            </div>
            .
          </div>
        )}
        {/* edit serie modale */}
        {edit && (
          <div
            id="add_serie_modale_update"
            className="add_serie_modale"
            onClick={closeUpdateSerieModale}
          >
            <div className="add_serie_modale_content">
              <h2>Update serie : {updatedSerie?.titre}</h2>
              <form action="">
                <div className="add_serie_form">
                  <div className="add_serie_form_left">
                    <div className="input_block">
                      <label htmlFor="titre">Title</label>
                      <input
                        type="text"
                        name="titre"
                        id="titre"
                        placeholder="Title"
                        value={updatedSerie.titre}
                        onChange={onUpdateHandler}
                        required
                      />
                    </div>
                    <div className="input_block">
                      <label htmlFor="user">Authorized users</label>
                      <select
                        name="fk_utilisateur"
                        id="user-up"
                        disabled={allUsersUp?.length === 0 ? true : false}
                      >
                        {allUsersUp?.map((u, i) => {
                          if (u._id !== loggedUser.id) {
                            return (
                              <option
                                id={u._id}
                                key={i}
                                value={u.nom_utilisateur}
                              >
                                {u?.nom_utilisateur}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </select>
                      <button
                        className="add_user"
                        disabled={allUsersUp?.length === 0 ? true : false}
                        onClick={
                          allUsersUp?.length === 0
                            ? null
                            : addUserToListOnUpdate
                        }
                        style={
                          allUsersUp?.length === 0
                            ? { opacity: "0.5", cursor: "not-allowed" }
                            : {}
                        }
                      >
                        Add Selected User
                      </button>
                    </div>
                  </div>
                  <div className="add_serie_form_right">
                    <div className="users_block">
                      {usersUp?.map((u, i) => {
                        return (
                          <div
                            key={i}
                            className="user_added"
                            id={`${u._id}-${u.nom_utilisateur}-parent`}
                            title={`${u.nom_utilisateur}`}
                            style={
                              updatedSerie.fk_utilisateur === u._id
                                ? {
                                    border: "2px solid #D91D6F",
                                    userSelect: "none",
                                  }
                                : {}
                            }
                          >
                            {u.nom_utilisateur[0]}
                            {updatedSerie.fk_utilisateur !== u._id && (
                              <span
                                id={`${u._id}-${u.nom_utilisateur}`}
                                title={`${u.nom_utilisateur}`}
                                className="delete_user"
                                onClick={removeUser}
                              >
                                x
                              </span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="add_serie_form_btns">
                  <button
                    type="button"
                    id="back_update"
                    onClick={closeUpdateSerieModale}
                  >
                    {loading && (
                      <span className="create_spin">
                        <AiOutlineLoading3Quarters />
                      </span>
                    )}{" "}
                    Back
                  </button>
                  <button type="button" id="cree" onClick={updateSerie}>
                    {updateStatus}
                  </button>
                </div>
              </form>
            </div>
            .
          </div>
        )}
        <ToastContainer />
      </div>
    );
  }
};

export default Series;
